module.exports = __webpack_public_path__ + "static/media/Fusion_Markets_RAF_FSA.952aabd8.docx";